/**
 * @desc 这部分存放公共的函数
 */
import { fontEndConfig } from './utils';
/**
 * @description 检测是否为非空对象
 * @param {Object} obj 原对象
 * @returns {Boolean}
 */
export function judgeObj(obj) {
    if (!obj
        || Object.prototype.toString.call(obj) !== '[object Object]'
        || JSON.stringify(obj) === '{}') {
        return false;
    }
    return true;
}
/**
 * @description 检测是否为非空数组
 * @param {Array} arr 原数组
 * @returns {Boolean}
 */
export function judgeArr(arr) {
    if (!arr
        || Object.prototype.toString.call(arr) !== '[object Array]'
        || JSON.stringify(arr) === '[]') {
        return false;
    }
    return true;
}
/**
 * @description 检测是否为空串
 * @param {String} str 原字符串
 * @returns {Boolean}
 */
export function judgeEmptyStr(str) {
    const newStr = typeof (str) === 'string' ? str.replace(/^\s*|\s*$/g, '') : str;
    return !!newStr || newStr === 0;
}
/**
 * @description 查询对象数组中是否存在某一个属性值的对象,存在返回其所在位置，否则返回false
 * @param {Array} arr 原数组
 * @param {String} key 属性名
 * @param {String} value 属性值
 * @returns {Boolean}
 */
export function searchKey(arr, key, value) {
    if (!judgeArr(arr)) {
        return false;
    }
    let resultIndex;
    const result = arr.filter((item, index) => {
        if (item[key] === value) {
            resultIndex = index;
        }
        return item[key] === value;
    });
    return result.length > 0 ? resultIndex : false;
}
/**
 * @description 对小于9的数字补0
 * @param {Number} num 原数字
 * @returns 返回补全的数字
 */
export function supplementZero(num) {
    if (typeof (num) !== 'number') {
        return false;
    }
    return num > 9 ? num : `0${num}`;
}
/**
 * @description 处理时间将毫秒转化为月日时分
 * @param {String|Number} time 原毫秒数
 * @returns 返回 月-日 时：分 格式的时间
 */
export function dealTime(time) {
    if (!time) {
        return '';
    }
    const timeToF = new Date(time);
    //   let y = timeToF.getFullYear();
    const m = supplementZero(timeToF.getMonth() + 1);
    const d = supplementZero(timeToF.getDate());
    const h = supplementZero(timeToF.getHours());
    const min = supplementZero(timeToF.getMinutes());
    //   let s = timeToF.getSeconds();
    return `${m}-${d} ${h}:${min}`;
}
/**
 * @description 对对象数组某一项更新属性值
 * @param {Array} arr 源数组
 * @param {Number} index 某一项
 * @param {Object} keyValObj 需要更新的属性键值对对象
 * @returns 返回更新过属性值的数组
 */
export function updateArr(arr, index, keyValObj) {
    if (!judgeArr(arr)) {
        return false;
    }
    if (typeof (index) !== 'number') {
        return false;
    }
    if (!judgeObj(arr[index]) || !judgeObj(keyValObj)) {
        return false;
    }
    const newArr = JSON.parse(JSON.stringify(arr));
    Object.keys(keyValObj).forEach((key) => {
        if (newArr[index][key] !== undefined) {
            newArr[index][key] = keyValObj[key];
        }
    });
    return newArr;
}
/**
 * @description 对象数组排序
 * @param {String} sortKey 按该属性排序
 * @param {Boolean} isSeq 是否顺序排序，默认倒序
 * @returns 返回排序之后的数组
 */
export function sortBy(sortKey, isSeq) {
    let isSeqR = isSeq;
    // 第二个参数没有传递 默认倒序排列
    if (isSeqR === undefined) {
        isSeqR = -1;
    }
    else {
        isSeqR = (isSeqR) ? 1 : -1;
    }
    return function _sort(a, b) {
        const aValue = a[sortKey];
        const bValue = b[sortKey];
        if (aValue < bValue) {
            return isSeqR * -1;
        }
        if (aValue > bValue) {
            return isSeqR * 1;
        }
        return 0;
    };
}
/**
 * @description 2018-11-08 17:23:01 => 11-08 17:23
 * @param {String} ori 按该属性排序
 * @returns {String} 返回处理之后的数据
 */
export function strTime(ori) {
    if (typeof (ori) !== 'string') {
        return false;
    }
    const oArr = ori.split(' ');
    const ydArr = oArr[0].split('-');
    const msArr = oArr[1].split(':');
    ydArr.splice(0, 1);
    msArr.splice(2, 1);
    return `${ydArr.join('-')} ${msArr.join(':')}`;
}
/**
 * @description 对象数组去重[{},{}] （依据key对应的值去重arr）
 * @param {Array} arr 源数组
 * @param {String} key 属性名
 * @returns {Object} resultArr copyArr 返回处理之后的数组以及重复项
 */
export function noSameArr(arr, key) {
    if (judgeArr(arr) && key) {
        const arrLen = arr.length;
        const recordObj = {};
        const resultArr = [];
        const copyArr = [];
        for (let i = 0; i < arrLen; i += 1) {
            let isHas = true;
            if (!recordObj[arr[i][key]]) {
                recordObj[arr[i][key]] = true;
                isHas = false;
            }
            else {
                copyArr.push(arr[i]);
            }
            if (!isHas) {
                resultArr.push(arr[i]);
            }
        }
        return { resultArr, copyArr };
    }
    return { resultArr: [], copyArr: [] };
}
/**
 * @description 去除数组项中的空串
 * @param {Array} arr 源数组
 * @returns {Array} 返回处理之后的数组
 */
export function noEmptyArr(arr) {
    if (judgeArr(arr)) {
        const rArr = arr.filter(item => item !== '');
        return judgeArr(rArr) ? rArr : false;
    }
    return false;
}
export function getUrlVars(url) {
    const vars = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        vars[key] = value;
    });
    return vars;
}
/**
 * 比较两个对象或数组是否值一致
 * @returns {boolean}
 */
export function isEqual(oldOne, newOne) {
    if (getDataType(oldOne) !== 'Array' && getDataType(oldOne) !== 'Object') {
        console.warn('ATTENTION: isEqual函数的参数类型应为对象或数组');
        return false;
    }
    return _checkEq(oldOne, newOne);
}
function _checkEq(oldOne, newOne) {
    if (Object.prototype.toString.call(oldOne) !== Object.prototype.toString.call(newOne)) {
        return false;
    }
    if (typeof (oldOne) !== 'object') {
        return oldOne === newOne;
    }
    switch (Object.prototype.toString.call(oldOne)) {
        case '[object Array]':
            const oldOneLen = oldOne.length;
            const newOneLen = newOne.length;
            if (oldOneLen !== newOneLen) {
                return false;
            }
            let flag = true;
            for (let i = 0; i < oldOneLen; i += 1) {
                const item = oldOne[i];
                const item2 = newOne[i];
                if (!_checkEq(item, item2)) {
                    flag = false;
                    break;
                }
            }
            return flag;
        case '[object Object]':
            const oldOneKeysArr = Object.keys(oldOne);
            const newOneKeysArr = Object.keys(newOne);
            const oldOneKeysArrLen = oldOneKeysArr.length;
            const newOneKeysArrLen = newOneKeysArr.length;
            if (oldOneKeysArrLen !== newOneKeysArrLen) {
                return false;
            }
            let flag2 = true;
            for (let i = 0; i < oldOneKeysArrLen; i += 1) {
                const key = oldOneKeysArr[i];
                const key2 = newOneKeysArr[i];
                if (key !== key2) {
                    flag2 = false;
                    break;
                }
                const item = oldOne[key];
                const item2 = newOne[key2];
                if (!_checkEq(item, item2)) {
                    flag2 = false;
                    break;
                }
            }
            return flag2;
        default:
            console.warn('ATTENTION: 暂时不支持除基本类型以及数组，对象之外的值的比较');
    }
}
/**
 * @description 获取数据类型
 * @param 所需数据
 * @returns {String} 数据类型（首字母大写）
 * */
export function getDataType(data) {
    return Object.prototype.toString.call(data).slice(1, -1).split(' ')[1];
}
/**
 * @description 对象数组数据添加key
 * @param {Array} arr 原数组
 * @returns {Array}
 * */
export function setKey(data) {
    const type = getDataType(data);
    if (type !== 'Array') {
        console.error(`setKey方法参数要求为Array,实际接收为${type}。错误数据：`, data);
        return data;
    }
    const dealData = data.map((item, index) => {
        if (getDataType(item) === 'Object') {
            const time = new Date().getTime();
            if (!item.key) {
                item.key = `souche_${index}_${time}`;
            }
        }
        return item;
    });
    return dealData;
}
/**
 * number格式： 最多两位小数
 * @returns {number}
 */
export function fixPrice(v) {
    const _v = Number(v);
    if (Number.isNaN(_v)) {
        console.warn('fixPrice 参数应为数字');
        return 'NaN';
    }
    return Number.isInteger(_v) ? _v :
        (String(_v).split('.')[1].length === 1 ? Number(_v.toFixed(1)) : Number(_v.toFixed(2)));
}
/**
 * 倒计时|已开始时间
 * @property time 终止时间 计算现在到time之间的差时
 * @property desc [可选] {enum} 'down'|'up' 计算倒计时还是已开始时间
 * @returns 相差的时分秒 => 00:02:12
 */
export function countDown(time, desc = 'down') {
    let _time = time;
    if (!new Date(_time).getTime()) {
        _time = time.replace(/-/g, '/');
        if (!new Date(_time).getTime()) {
            return '00:00:00';
        }
    }
    const termT = new Date(_time).getTime();
    const now = new Date().getTime();
    const sub = desc === 'up' ? now - termT : termT - now;
    let subT = Math.floor(sub / 1000);
    subT = subT < 0 ? 0 : subT;
    const h = Math.floor(subT / 3600);
    const m = Math.floor((subT % 3600) / 60);
    const s = Math.floor((subT % 3600) % 60);
    return `${supplementZero(h)}:${supplementZero(m)}:${supplementZero(s)}`;
}
/**
 * 秒 => 时分秒
 * @property time 秒
 * @returns 时分秒 => 00:02:12
 */
export function countUp(time) {
    const h = Math.floor(time / 3600);
    const m = Math.floor((time % 3600) / 60);
    const s = Math.floor((time % 3600) % 60);
    return `${supplementZero(h)}:${supplementZero(m)}:${supplementZero(s)}`;
}
/**
 * @desc 判断浏览器是否支持全屏
 */
export function judgeCanFullScreen() {
    return document.fullscreenEnabled ||
        // @ts-ignore
        document.mozFullScreenEnabled ||
        // @ts-ignore
        document.webkitFullscreenEnabled ||
        // @ts-ignore
        document.msFullscreenEnabled || false;
}
/**
 * @desc 是否全屏
 * @return true 全屏 false 非全屏
 */
export function isFullScreen() {
    // @ts-ignore
    return !!(document.fullscreen || document.mozFullScreen ||
        // @ts-ignore
        document.webkitIsFullScreen || document.msFullScreenElement);
}
/**
 * @desc 全屏方法
 * @property el：需要全屏的dom 元素
 * @argument 可以通过设置dom id获取
 */
export function fullScreen(el) {
    if (!isFullScreen()) { // 进入全屏,多重短路表达式
        (el.requestFullscreen && el.requestFullscreen()) ||
            (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
            (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) ||
            (el.msRequestFullscreen && el.msRequestFullscreen()) ||
            (el.oRequestFullscreen && el.oRequestFullscreen());
    }
    else { // 退出全屏,三目运算符
        document.exitFullscreen ? document.exitFullscreen() :
            // @ts-ignore
            document.mozCancelFullScreen ? document.mozCancelFullScreen() :
                // @ts-ignore
                document.webkitExitFullscreen ? document.webkitExitFullscreen() :
                    // @ts-ignore
                    document.webkitCancelFullScreen ? document.webkitCancelFullScreen() :
                        // @ts-ignore
                        document.msExitRequestFullscreen ? document.msExitRequestFullscreen() :
                            // @ts-ignore
                            document.msExitFullscreen ? document.msExitFullscreen() :
                                // @ts-ignore
                                document.msCancelFullScreen ? document.msCancelFullScreen() :
                                    // @ts-ignore
                                    document.oCancelFullScreen ? document.oCancelFullScreen() : '';
    }
}
/**
 * @desc 展示字段值 如无该字段值 返回fontEndConfig.noValueReplace: '--'
 * @argument 新增功能：是否对0进行处理（涉及太多值的使用，只能增字段来处理）
 * @property v               需要处理的值
 * @property add             处理后可添加的后缀
 * @property symbol          无值时需代替的值
 * @property isReplaceZero   是否需要处理0
 */
export function dealValueShow(v, add, symbol, isReplaceZero = false) {
    const isHas = isReplaceZero ? v : v || v === 0;
    const isAdd = !!add;
    const dealSymbol = symbol ? symbol.toString() : fontEndConfig.noValueReplace;
    return isHas ? isAdd ? `${v}${add}` : v : dealSymbol;
}
/**
 * @desc 处理list数据 如字段返回假值 默认返回'--'
 * @param gistData 处理数据依据 object[]
 * @param data 处理数据依据 object[]
 * @param add 处理数据依据 值拼接 string
 * @param symbol 替换值 string
 * @param isReplace0 替换值 0 是否替换
 */
export function dealListValueShow({ gistData, data, add, symbol = fontEndConfig.noValueReplace, isReplace0 = false }) {
    const columsShowList = gistData.map((item) => (item.dataIndex || item.key));
    return data.map((item) => {
        columsShowList.forEach((key) => {
            if (!isReplace0) {
                item[key] = item[key] === 0 ? item[key] : dealValueShow(item[key], add, symbol);
            }
            else {
                item[key] = dealValueShow(item[key], add, symbol);
            }
        });
        return item;
    });
}
/**
 * @desc 展示字段值2 如无该字段值 返回 0
 */
export function dealValueShow2(v) {
    return v ? v : 0;
}
/**
 * @desc 'yyyy-mm-dd hh:mm:ss' 返回 'hh:mm'
 */
export function subTime(t) {
    if (t.split(' ').length === 2) {
        const _t = t.split(' ')[1];
        const _t1 = _t.split(':');
        _t1.pop();
        return _t1.join(':');
    }
    return '00:00';
}
/**
 * @desc 车序号 填满三位数 1 => 001; 22 => 022; 333=>333;
 */
export function dealCarNum(v) {
    const _isNumber = parseInt(String(v), 10);
    const _v = _isNumber ? String(_isNumber) : fontEndConfig.noValueReplace;
    if (_isNumber) {
        const _d = _v.length;
        switch (_d) {
            case 1:
                return `00${_v}`;
            case 2:
                return `0${_v}`;
        }
    }
    return _v;
}
/* 为数组中生成key
 * @param {[]} arr
 * @returns {[]}
 */
export function uniqueArr(arr) {
    const newArr = [];
    arr.map((item) => {
        // @ts-ignore
        newArr.push(Object.assign(Object.assign({}, item), { key: `${new Date().getTime()}${Math.random()}` }));
    });
    return newArr;
}
/**
 * @description 获取cookie
 * @param {String} param 参数
 * @returns {String} 返回参数的值
 */
export function gainCookieByKey(param) {
    const cookieStr = document.cookie;
    if (cookieStr) {
        const cookieArr = cookieStr.split(';');
        const cArrLen = cookieArr.length;
        for (let i = 0; i < cArrLen; i += 1) {
            const kv = cookieArr[i].split('=');
            kv[0] = kv[0].replace(/(^\s*)|(\s*$)/g, '');
            if (kv[0] === param) {
                kv[1] = kv[1].replace(/(^\s*)|(\s*$)/g, '');
                return kv[1];
            }
        }
    }
    return '';
}
/**
 * 清除cookie
 */
export function clearCookie(name) {
    document.cookie = `${name} + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}
/**
 * 获取所有的资源code
 * @param {[]} arr
 * @returns {any}
 */
export function getAllResources(arr) {
    const newArr = [];
    arr.map((item) => {
        newArr.push(item.code);
    });
    return newArr;
}
/**
 * 根据 code 获取对应的 key
 * @param arr
 * @param code
 * @param formKey
 * @param returnKey
 */
export function getNameByCode(arr, code, formKey, returnKey) {
    for (const item of arr) {
        if (item[formKey] === code) {
            return item[returnKey];
        }
    }
}
/**
 * 获取路径参数
 * */
export function getQueryString(url) {
    const qs = url ? url.split('?')[1] : location.search.substr(1);
    const args = {};
    const items = qs.length ? qs.split('&') : [];
    let item = null;
    const len = items.length;
    for (let i = 0; i < len; i += 1) {
        item = items[i].split('=');
        const name = decodeURIComponent(item[0]);
        const value = decodeURIComponent(item[1]);
        if (name) {
            args[name] = value;
        }
    }
    return args;
}
/**
 * 跳转检测报告
 * */
export function jumpReport(url) {
    const oldReportUrl = url;
    const newReportUrl = process.env.MUJI_APP_REPORT;
    const urlParams = getQueryString(oldReportUrl);
    const code = urlParams['Code'];
    const reportCode = urlParams['reportCode'];
    const reportCodeReal = code || reportCode;
    window.open(`${newReportUrl}${reportCodeReal}`);
}
/**
 * @desc 可用余额列的展示：小于0时 展示为0（违约待扣款XXX元）
 */
export function availableMoney(v) {
    const temp = thousandBitSeparator(Math.abs(v));
    return v ? v < 0 ? `0 (违约待扣款${temp}元)` : temp : fontEndConfig.noValueReplace;
}
/**
 * @desc 千分位分割符号
 */
export function thousandBitSeparator(num) {
    return num && (num.toString().indexOf('.') !== -1 ? num.toString().replace(/([-+]?\d)(?=(\d{3})+\.)/g, ($0, $1) => {
        return `${$1},`;
    }) : num.toString().replace(/([-+]?\d)(?=(?:\d{3})+$)/g, ($0, $1) => {
        return `${$1},`;
    }));
}
/**
 * @desc 将string形式转换为可以比较的number类型
 */
export function toNumber(str) {
    return Number(str) ? Number(str) : 0;
}
export function toNumberOrEmpty(str) {
    return Number(str) || Number(str) === 0 ? Number(str) : '';
}
/*
 * 数据填充 0
 * @param {number | string} num
 * @param {number | string} len
 * @returns {any}
 */
export function paddingZero(num, len) {
    return (Array(len).join('0') + num).slice(-len);
}
/**
 * 首字母大写
 * @param {String} str
 * @returns {any}
 */
export function firstUpperCase(str) {
    return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
}
/**
 * 输入是否有相同项目
 * @param arr
 * @returns {any}
 */
export function arrIsRepeat(arr) {
    const hash = {};
    for (const i in arr) {
        if (hash[arr[i]]) {
            return true;
        }
        hash[arr[i]] = true;
    }
    return false;
}
/**
 * some
 * every
 * find
 * map
 * forEach
 * @param arr
 */
export function checkArrVal(arr) {
    return arr.filter((item) => {
        return item.type !== 'isMax' && item.max <= item.min;
    });
}
/**
 * 格式化数字和空格
 * 0 或 '0' 或 '999' ==> 数字
 * '' 或 undefined 或 null ==> ''
 * @param {number | string | null} val
 * @returns {number | string}
 */
export function formatNumOrSpace(val) {
    if (val === undefined || val === null || val === '') {
        return '';
    }
    return Number(val) ? Number(val) : 0;
}
/**
 * 校验上下限
 * 两个值都有，对比最大值是否大于最小值
 */
export function checkLowUpperVal(minVal, maxVal) {
    return ((String(minVal) && String(maxVal)) && (Number(maxVal) < Number(minVal)));
}
/**
 * 获取begin - end 的数组
 * 例如：begin:3 - end:10
 * return [3,4,5,6,7,8,9]
 * */
export function range(begin, end) {
    const result = [];
    for (let i = begin; i < end; i += 1) {
        result.push(i);
    }
    return result;
}
/**
 * mapping key -- value
 */
export function mappingKeyToVal(arr, key) {
    let item = {};
    for (item of arr) {
        if (item.key === key || item.keyWord === key) {
            return item.value;
        }
    }
}
/**
 * mapping value -- key
 */
export function mappingValToKey(arr, value) {
    let item = {};
    for (item of arr) {
        if (item.value === value) {
            return item.key;
        }
    }
}
/**
 * @desc 带颜色日志
 * @arguments 使用方式： 如 logColor("my name is : ", "zjl", "color: red")
 * 最后一个参数可以传颜色样式的字符串，如不传，则默认是黑色
 * */
export function logColor(...args) {
    const toColor = {
        red: '#FF4040',
        green: '#1DBF6E',
        orange: '#FF6619',
        purple: '#5A48CD',
        magenta: '#FF19AC',
    };
    let finalColor = '#000';
    const _color = args[args.length - 1];
    const regExp = /^color:([\s|\w]*)$/;
    const hasMatch = regExp.exec(_color);
    if (hasMatch && hasMatch[1].trim()) {
        const temp = hasMatch[1].trim();
        // @ts-ignore
        finalColor = toColor[temp] ? toColor[temp] : temp;
        args.pop();
    }
    try {
        let index = 0;
        const tempArr = [];
        let j = 0;
        while (index < args.length) {
            if (getDataType(args[index]) === 'String' || getDataType(args[index]) === 'Undefined' || getDataType(args[index]) === 'Number') {
                tempArr[j] = `${tempArr[j] ? `${tempArr[j]} ` : ''}${args[index]}`;
            }
            else {
                tempArr[j + 1] = args[index];
                j += 2;
            }
            index += 1;
        }
        tempArr.map((item) => {
            if (getDataType(item) === 'String') {
                console.log(`%c${item}`, `color:${finalColor}`);
            }
            else {
                console.log(item);
            }
        });
    }
    catch (err) {
        console.error('Err in function logColor is: ', err);
        console.log(...args);
    }
}
/**
 * @desc 带颜色日志
 * @arguments 使用方式： 如 logColor("my name is : ", "zjl", "color: red")
 * 最后一个参数可以传颜色样式的字符串，如不传，则默认是黑色
 * */
export function getUrlParam(param) {
    try {
        const urlHash = window.location.hash;
        const tempArr = urlHash.split('?');
        const tempArr2 = tempArr[1].split('&');
        const tempArr2Len = tempArr2.length;
        for (let i = 0; i < tempArr2Len; i += 1) {
            const kv = tempArr2[i].split('=');
            kv[0] = kv[0].replace(/(^\s*)|(\s*$)/g, '');
            if (kv[0] === param) {
                kv[1] = kv[1].replace(/(^\s*)|(\s*$)/g, '');
                return kv[1];
            }
        }
        return '';
    }
    catch (err) {
        // console.log('err in getUrlParam function', err);
        return '';
    }
}
/**
 * @desc 设置rem值
 * */
export function onResize(elementId, designSizeH) {
    // 实际区域宽高
    const dom = document.getElementById(elementId);
    const domH = dom.clientHeight;
    const dealH = domH;
    const rem = dealH * 100 / designSizeH;
    document.getElementsByTagName('html')[0].style.fontSize = `${rem}px`;
}
/**
 * @desc 设置rem值
 * */
export function clearObj(obj) {
    if (getDataType(obj) === 'Object') {
        for (const _prop in obj) {
            if (obj[_prop] === undefined) {
                delete obj[_prop];
            }
        }
    }
    return obj;
}
/**
 * @desc 处理列表多选项-除去特定条件
 * 即： 对应去除 selectedRows里{disabled:true}的项 去除selectedRowKeys的对应项
 * @argument {
 *    keys string[]                                           对应 selectedRowKeys
 *    rows {[key:string]: any}[]                              对应 selectedRows
 *    options                                                 对应 筛选条件
 *      {
 *       excludeObj: {[key:string]: any},      必须不包含的项  对应 { disabled: true }
 *       keyName: string,                                    对应 keys的值对应rows里的属性名
 *     }
 * }
 */
export function dealRowAndKeys({ keys = [], rows = [], options: { excludeObj = {}, keyName = '', }, }) {
    console.log('keys', keys, 'rows', rows);
    const excludeObjKeys = Object.keys(excludeObj);
    const tempRows = [];
    const excludeRows = rows.filter((item) => {
        // 必须不包含excludeObjKeys的项
        let hasExclude = false;
        for (const k in item) {
            if (excludeObjKeys.includes(k) && item[k] === excludeObj[k]) {
                hasExclude = true;
                break;
            }
        }
        !hasExclude ? tempRows.push(item) : '';
        return hasExclude;
    });
    const excludeKeys = excludeRows.map((item) => {
        return item[keyName];
    });
    const dealKeys = keys.filter((item) => {
        return !excludeKeys.includes(item);
    });
    const dealRows = judgeArr(tempRows) ? tempRows : rows;
    return [dealKeys, dealRows];
}
export const dealTimeAnotherLine = (time, connect) => {
    return time.replace(connect || ' ', '\n');
};
export function deleteRate(num) {
    const hasRate = String(num).indexOf('%') !== -1;
    return hasRate ? String(num).replace('%', '') : num;
}
